import React from 'react';
import { Select, Col, Row } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import './index.css';

const { Option } = Select;
export const SelectBox = (prop) => {
  const { onFilterChange, filterData } = prop;
  const children = [];
  for (let c of filterData.criterias) {
    children.push(<Option key={c.nameForSearch} title={c.nameForDisplay}>{c.nameForDisplay}</Option>);
    const spanTag  = Array.from(document.querySelectorAll('.select-box .ant-select-selection-item-content'))
    .find(span => span.innerText.trim() === c.nameForDisplay.trim());
     if (spanTag) {
      spanTag.setAttribute("title", c.nameForDisplay);
     }
  }

  function handleChange(values) {
    onFilterChange({
      filterName: filterData.name,
      values: values
    }
    );
  }

  return (
    <Row>
      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="col select-col">
        <h4 className="select-label"><label> {filterData.name}</label></h4>
        <div className="select-box">
          <Select
            mode="multiple"
            className="select-options"
            placeholder="Please select"
            defaultValue={[]}
            onChange={handleChange}
            size="large"
          >
            {children}
          </Select>
        </div>
      </Col>
    </Row>
  );
}
